import { FileDownloadOutlined as FileDownloadOutlinedIcon } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import type { IconButtonProps } from '@mui/material/IconButton';
import type { FunctionComponent } from 'react';

type ExportIconButtonProps = Pick<IconButtonProps, 'aria-label' | 'disabled' | 'onClick'> & {
    readonly isPending?: boolean;
    readonly tooltip: string;
};

export const ExportIconButton: FunctionComponent<ExportIconButtonProps> = ({
    'aria-label': ariaLabel,
    disabled,
    isPending,
    onClick,
    tooltip,
}) => (
    <Tooltip title={tooltip}>
        <IconButton
            aria-label={ariaLabel}
            color="secondary"
            disabled={disabled === true || isPending === true}
            sx={{
                '&.Mui-disabled': {
                    color: isPending === true ? 'primary.main' : 'action.disabled',
                },
            }}
            onClick={onClick}
        >
            {isPending === true ? <CircularProgress size={20} /> : <FileDownloadOutlinedIcon />}
        </IconButton>
    </Tooltip>
);
